import AppointmentsSection from '@components/AppointmentsSection'
import RemindersSection from '@components/RemindersSection'
import MessagesSection from '@components/MessagesSection'
import Notifications from '@components/Notifications'
import { useAdminPanel } from '@hooks/useAdminPanel'
import AdminProducts from '@pages/admin/AdminPage'
import styles from '@styles/AdminPanel.module.css'
import AdminOffers from '@components/AdminOffers'
import Dashboard from '@components/Dashboard'
import Loading from '@components/Loading'
import Sidebar from '@components/Sidebar'

const AdminPanel = () => {
  const { activeSection, setActiveSection, notifications, isCollapsed, setIsCollapsed, appointments, searchTerm,
    darkMode, reminders, messages, loading, logout, dashboardData, toggleDarkMode, handleAppointmentStatus,
    handleSearch, filterItems, clearMessages, deleteAppointment } = useAdminPanel()

  const renderContent = () => {
    switch (activeSection) {
      case 'dashboard':
        return <Dashboard dashboardData={dashboardData} />
      case 'products':
        return <AdminProducts darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
      case 'appointments':
        return <AppointmentsSection appointments={appointments} filterItems={filterItems} handleAppointmentStatus={handleAppointmentStatus} deleteAppointment={deleteAppointment} />
      case 'messages':
        return <MessagesSection messages={messages} clearMessages={clearMessages} />
      case 'reminders':
        return <RemindersSection reminders={reminders} />
      case 'offers':
        return <AdminOffers darkMode={darkMode} />
      default:
        return <Dashboard dashboardData={dashboardData} />
    }
  }

  if (loading) return <Loading />

  return (
    <div className={`${styles.container} ${darkMode ? styles.dark : ''}`}>
      <Sidebar
        isCollapsed={isCollapsed}
        setIsCollapsed={setIsCollapsed}
        activeSection={activeSection}
        setActiveSection={setActiveSection}
        searchTerm={searchTerm}
        handleSearch={handleSearch}
        toggleDarkMode={toggleDarkMode}
        logout={logout}
      />

      <main className={styles.mainContent}>{renderContent()}</main>

      <Notifications notifications={notifications} />
    </div>
  )
}

export default AdminPanel
